import React, { FunctionComponent } from 'react';
import { Container } from 'semantic-ui-react';
import { ClassProp } from 'helpers/types';
import withStyles from 'react-jss';
import FillMUGModal from './components/FillMUGModal';

import styles from './MerchantAudience.styles';

type Styles = ClassProp<ReturnType<typeof styles>>;

type Props = {
  classes: Styles;
};

const MerchantAudience: FunctionComponent<Props> = ({ classes }) => (
  <Container>
    <FillMUGModal
      trigger={<button className={classes.MUGModalButton}>Fill Mug</button>}
    />
  </Container>
);

export default withStyles(styles)(MerchantAudience);
